//----------------------------------------------------
// VideoUpload.jsx — Logboek24 inspectievideo’s uploaden
//----------------------------------------------------
import React, { useState, useRef } from "react";
import { apiUrl } from "../config/api";

export default function VideoUpload() {
  const fileInputRef = useRef();
  const [videoPreview, setVideoPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [serverFile, setServerFile] = useState(null);

  const handleVideoChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Alleen MP4-video’s toestaan
    if (!file.type.startsWith("video/")) {
      alert("❌ Alleen MP4-video’s zijn toegestaan.");
      return;
    }

    // Toon preview
    const previewUrl = URL.createObjectURL(file);
    setVideoPreview(previewUrl);

    // Upload naar backend
    const formData = new FormData();
    formData.append("file", file);
    const token = localStorage.getItem("token");

    try {
      setUploading(true);
      const res = await fetch(apiUrl("/api/surveys/upload"), {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();

      if (data.fileUrl) {
        console.log("✅ Video-upload gelukt:", data.fileUrl);
        setServerFile(apiUrl(data.fileUrl));
      } else {
        console.warn("⚠️ Upload voltooid maar geen fileUrl ontvangen:", data);
      }
    } catch (err) {
      console.error("❌ Upload mislukt:", err);
      alert("Upload mislukt, probeer het opnieuw.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="p-4 bg-white rounded-xl shadow-md w-full max-w-lg mx-auto mt-6">
      <h2 className="text-lg font-semibold mb-3">🎥 Inspectievideo uploaden</h2>
      <input
        type="file"
        accept="video/mp4,video/quicktime"
        ref={fileInputRef}
        onChange={handleVideoChange}
        className="mb-4"
      />

      {videoPreview && (
        <video
          src={videoPreview}
          controls
          className="rounded-lg border border-gray-300 shadow-sm mb-3 w-full"
        />
      )}

      {uploading && <p className="text-blue-500">Bezig met uploaden...</p>}

      {serverFile && (
        <p className="text-sm text-green-700">
          ✅ Video opgeslagen op server:&nbsp;
          <a
            href={serverFile}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            {serverFile}
          </a>
        </p>
      )}
    </div>
  );
}
